/**
 * @deprecated
 * Importing directly from this file is deprecated. Please import from `wix-ui-test-utils/unidriver`.
 */

import { UniDriver } from '@wix/unidriver-core';

export interface BaseUniDriver {
  /** @returns {boolean} true - if component exists */
  exists: () => Promise<boolean>;
  /**
     @deprecated use .base instead
     @returns result of getNative() call - usually the component element
     or an object with page, selector and element in case @wix/unidriver-puppeteer is used.
  */
  element: () => Promise<any>;
  /** @returns click on the element result */
  click: () => Promise<void>;
  /** @returns {UniDriver} wrapper of base element */
  base: UniDriver;
}

export const baseUniDriverFactory = (base: UniDriver): BaseUniDriver => {
  return {
    exists: () => base.exists(),
    element: () => base.getNative(),
    click: () => base.click(),
    base,
  };
};
